import { Alert, AlertDescription, AlertTitle } from "@chakra-ui/react";
import { AlertIcon } from "view-layer/components/common/icons/AlertIcon";

export const PaymentPendingFor3dsCard = () => (
  <Alert status="info" variant="info" data-testid="payment-3dspending-message">
    <AlertIcon status="loading" />
    <AlertTitle>Payment in progress</AlertTitle>
    <AlertDescription>Your payment is pending for 3DS authentication.</AlertDescription>
  </Alert>
);